import {
  ActionsGroup,
  Button,
  DialogFooterV2,
  HexIcon,
  Icons,
  Inset,
  useCloseDialog,
  useSwipeableViews,
  Typography,
  Stack,
} from '@cast/design-system';

type FeedbackSlideProps = {
  variant: 'success' | 'error';
};

export const FeedbackSlide = ({ variant }: FeedbackSlideProps) => {
  const swipeableCtx = useSwipeableViews();
  const closeDialog = useCloseDialog();

  if (variant === 'success') {
    return (
      <Stack data-testid="success-slide">
        <Inset py>
          <Stack direction="row" alignItems="center" gap={12}>
            <HexIcon variant="success" size={50} />
            <Typography variant="h6">
              Great! Edge location offboarded successfully!
            </Typography>
          </Stack>
        </Inset>
        <DialogFooterV2
          divider
          endContent={
            <Button
              onClick={closeDialog}
              variant="primary"
              testId="close-button"
            >
              Close
            </Button>
          }
        />
      </Stack>
    );
  }

  return (
    <Stack data-testid="error-slide">
      <Inset py>
        <Stack direction="row" alignItems="center" gap={12}>
          <HexIcon
            variant="error"
            size={44}
            animationType="pulsateSlow"
            icon={<Icons.Warning />}
          />
          <Typography variant="h6">Failed to offboard edge location</Typography>
        </Stack>
      </Inset>

      <DialogFooterV2
        divider
        endContent={
          <ActionsGroup>
            <Button onClick={closeDialog} variant="secondary">
              Close
            </Button>
            <Button
              testId="retry-button"
              onClick={() => swipeableCtx?.setSlide('setup')}
            >
              Retry
            </Button>
          </ActionsGroup>
        }
      />
    </Stack>
  );
};
